import React from "react";
import Layout from "../../components/Layout/layout";
import confChair from "../../assets/images/ConfChair1.jpeg";
import OrgSecy1 from "../../assets/images/OrgSecy1.jpeg";
import OrgSecy2 from "../../assets/images/OrgSecy2.jpeg";
const Contact = () => {
  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10">
      <div className="flex absolute md:mt-[-15vw] mt-[-45vw] ml-2 md:flex-row flex-col items-center w-full justify-center gap-12">
            <div className="text-[55px] text-white"
                style={{ fontFamily: 'Bebas Neue', textShadow: '2px 1px 0px #000' }}
            >
                CONTACT INFORMATION
            </div>
        </div>
        <div className="flex flex-col w-full md:w-3/4 px-10 md:px-20 mx-auto bg-white p-8 mb-10">
        <div className="text-cyan-800 flex justify-center items-center text-3xl mb-10 font-bold">
            GET IN TOUCH WITH US
          </div>
          <div className="flex flex-col md:flex-row m gap-2 md:justify-center items-start">
            <div className="flex flex-col md:mx-10 mx-2">
              <div className="text-cyan-800 text-2xl font-bold flex flex-row">
                <div >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                </div>
              <div>Mailing Address</div></div>
              <div className=" text-lg font-bold">Department of Civil Engg.<br/>
              IIT Guwahati, Assam - 781039</div>
            </div>
            <div className="flex flex-col md:mx-10 mx-2 mt-5">
            <div className="text-cyan-800 text-2xl font-bold flex flex-row">
                <div >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>

                </div>
              <div>Email Address</div></div>
              <div className=" text-lg font-bold">8icragee@iitg.ac.in</div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-3/4 px-10 md:px-20 py-20 border-2 bg-orange-600 mx-auto flex flex-col">
        
          <div className="text-white text-[4~vh] flex justify-center items-center text-4xl mb-5 font-bold">
            CONTACT THE OFFICIALS
          </div>
          <div className="flex flex-col justify-start items-start">
            {" "}
            <div class="md:p-4 lg:w-1/2 w-full my-5 ">
              <div class="flex border-2 rounded-lg md:flex-row flex-col bg-white items-center">
                <div class="">
                  <img src={confChair} className="w-full h-64 rounded-lg"/>
                </div>
                <div class="flex-grow p-8">
                  <h2 class="text-gray-900 text-xl title-font font-bold mb-3">
                    Prof. B.K. Maheshwari
                  </h2>
                  <p class="leading-relaxed text-base">IIT Roorkee</p>
                  <p class="leading-relaxed text-base">
                  Email ID: bk.maheshwari@eq.iitr.ac.in
                  </p>
                  <p class="leading-relaxed text-base">Phone: +91-1332-285450</p>
                </div>
              </div>
            </div>
            <div class="md:p-4 lg:w-1/2 w-full my-5">
              <div class="flex border-2 rounded-lg md:flex-row flex-col bg-white">
                <div class="">
                  <img src={OrgSecy1} className="w-full h-full rounded-lg"/>
                </div>
                <div class="flex-grow p-8">
                  <h2 class="text-gray-900 text-xl title-font font-bold mb-3">
                    Prof. Abhishek Kumar
                  </h2>
                  <p class="leading-relaxed text-base">IIT Guwahati</p>
                  <p class="leading-relaxed text-base">
                  Email ID: abhiak@iitg.ac.in
                  </p>
                  <p class="leading-relaxed text-base">Phone: +91-361-258-3329</p>
                </div>
              </div>
            </div>
            <div class="md:p-4 lg:w-1/2 w-full my-5">
              <div class="flex border-2 rounded-lg md:flex-row flex-col bg-white items-center">
                <div class="">
                  <img src={OrgSecy2} className="w-full h-full rounded-lg"/>
                </div>
                <div class="flex-grow p-8">
                  <h2 class="text-gray-900 text-xl title-font font-bold mb-3">
                    Prof. Rajib Sarkar
                  </h2>
                  <p class="leading-relaxed text-base">IIT (ISM) Dhanbad</p>
                  <p class="leading-relaxed text-base">
                    Email ID: rajib@iitism.ac.in
                  </p>
                  <p class="leading-relaxed text-base">Phone: +91-326-223-5878</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Contact;
